import { getEmailsApi, postEmailsApi } from "../sharedData/emailAPIs";
import axios from "axios";
import { tokenConfig } from "../utils/apiConfig";


/**
 * @param {Function,Function}
 */
export async function getEmails(succCallbackFunc, errCallbackFunc) {
    await axios
        .get(getEmailsApi, tokenConfig())
        .then(res => succCallbackFunc(res.data))
        .catch(err => {
            if (err instanceof String) { errCallbackFunc(err) }
            else { errCallbackFunc(JSON.stringify(err)) }
        })
}

/**
 * @param {Object,Function,Function}
 * reqBody:{
    * user_id: string,<required>
    * email_template_id: string,<required>
    * sent_to:[string (list of emails)]<required>
    * }
 */
export async function sendEmails(reqBody, succCallbackFunc, errCallbackFunc) {
    await axios
        .post(postEmailsApi, reqBody, tokenConfig())
        .then(res => succCallbackFunc(res.data))
        .catch(err => {
            if (err instanceof String) { errCallbackFunc(err) }
            else { errCallbackFunc(JSON.stringify(err)) }
        })
}
